<h1 mat-dialog-title>Clinic check-in</h1>
<div mat-dialog-content>
    <p>Clinic: <span *ngIf="clinic">{{clinic.name}}</span></p>
    <!-- <button *ngIf="!visited" class="check-in-button" color="primary" (click)="markArrived()" mat-raised-button>I have
        arrived</button>
    <div *ngIf="visited" class="checked-in-container">
        <p>Checked in</p>
        <mat-icon>check</mat-icon>
    </div> -->

    <app-bulk-process [orders]="outstandingOrders" (submitted)="refreshSchedule()" [currentSchedule]="schedule"></app-bulk-process>

    <div *ngIf="processedOrders.length > 0">
        <div *ngFor="let order of processedOrders">
            <span>
                <mat-icon color="primary">check</mat-icon>
            </span>
            <span>
                {{order.scheduleType}} | 
            </span>
            <span>
                {{order.order?.animalName ?? "Animal Name"}}
            </span>
            <span>
                , {{order.order?.weight ?? "Weight"}} kg
            </span>
            <span>
                , {{order.order?.referenceNumber ?? "Reference Number"}}
            </span>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
</div>